import { render, staticRenderFns } from "./HeaderWrapper.vue?vue&type=template&id=0c56b8e1&"
import script from "./HeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./HeaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports